import React from "react";
import { BsFillFileEarmarkTextFill } from "react-icons/bs";
import { IoReorderFourSharp } from "react-icons/io5";
import { FaGears } from "react-icons/fa6";
import NestedOption from "../Components/NestedOption";
function RenderFormList(props) {
  let { forms, showInactive } = props;

  // filter forms to be unique by formId, keep only the first one
  const seen = new Set();
  const uniqueForms = forms.filter((form) => {
    if (seen.has(form.formId)) {
      return false;
    } else {
      seen.add(form.formId);
      return true;
    }
  });

  forms = uniqueForms;

  forms.forEach((form) => {
    form.sections.sort((a, b) => {
      if (a.rank !== b.rank) {
        return a.rank - b.rank; // First, sort by rank
      } else {
        return new Date(a.created) - new Date(b.created);
      }
    });

    form.sections.forEach((section) => {
      section?.sectionFields?.sort((a, b) => {
        if (a.field.rank !== b.field.rank) {
          return a.field.rank - b.field.rank; // First, sort by rank
        } else {
          return new Date(a.field.created) - new Date(b.field.created);
        }
      });
    });
  });

  return (
    <ul style={{ padding: "0" }}>
      {forms &&
        forms.map((form) => {
          // if a form is disabled, we will return nothing if
          // the "Show inactive" is unchecked (false)
          if (showInactive || !form.isDisabled) {
            return (
              <NestedOption
                key={form.formId}
                optionId={form.formId}
                optionText={form.formName ? form.formName : form.name}
                icon={
                  <BsFillFileEarmarkTextFill
                    size={15}
                    style={{
                      color: form.isDisabled ? "grey" : "var(--accent-color)",
                    }}
                  />
                }
                optionPath={"/formsandfields/" + form.formId}
                contextMenuOption={"formLevel"}
              >
                {form.sections &&
                  form.sections.map((section) => {
                    return (
                      <NestedOption
                        key={section.sectionId}
                        sectionId={section.sectionId}
                        optionId={form.formId}
                        optionPath={
                          "/formsandfields/" +
                          form.formId +
                          "/section/" +
                          section.sectionId
                        }
                        optionText={section.name}
                        contextMenuOption={"sectionLevel"}
                        icon={<IoReorderFourSharp size={15} />}
                        isExpanded={section.isExpanded}
                      >
                        {section.sectionFields &&
                          section.sectionFields.map((field) => {
                            return (
                              <NestedOption
                                key={field.field.fieldId}
                                optionId={field.field.fieldId}
                                fieldId={field.field.fieldId}
                                optionText={field.field.name}
                                sectionId={section.sectionId}
                                contextMenuOption={"fieldLevel"}
                                icon={<FaGears size={15} />}
                                optionPath={
                                  "/formsandfields/" +
                                  form.formId +
                                  "/section/" +
                                  section.sectionId +
                                  "/field/" +
                                  field.field.fieldId
                                }
                              />
                            );
                          })}
                      </NestedOption>
                    );
                  })}
              </NestedOption>
            );
          } else if (showInactive === false && form.isDisabled) {
            // i dont want to see the inactive
            return;
          } else {
            //console.log("this case fell through: ", form);
          }
        })}
    </ul>
  );
}

export default RenderFormList;
